interface MainProps {
  children: React.ReactElement<any> | number | string | (React.ReactElement<any> | number | string)[];
  noLayout?: boolean;
}

const Main = ({ children, noLayout }: MainProps) => {
  if (noLayout) return <>{children}</>;

  return <main className="flex-grow">{children}</main>;
};

export default Main;
